import React from 'react'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { updatePortion } from 'services/fund'

export default function useUpdatePortion(refetch: () => void) {
    const { mutate } = useMutation({
        mutationFn: (payload: {
            moneyPool: String | undefined
            poolship: number
            amount: number
            is_delayed: boolean
        }) => {
            return updatePortion(payload)
        },
        onSuccess: (result, variables) => {
            toast.success(' با موفقیت انجام شد')
            refetch()
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
